/* pbk-range-limit.js
   一覧の範囲フィルタ（価格 / 重量ct / チェーン長）で「下限 > 上限」を選べないようにする。
   .pbk-range 内に min→max の順で並ぶ 2 つの <select.pbk-dd__select> を対象にし、
   一方の選択に応じて相手側の矛盾する option を disabled 化する。既存選択が矛盾したら
   「直前に操作した方」を優先し、もう一方を「なし」に補正する。
   ルース(main-collection-loose)・ジュエリー(main-collection-jewelry)共通で読み込む。 */
(function () {
  'use strict';

  function num(v) {
    if (v == null || v === '') return null;
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  /* select の全 option に対し、空値("なし")は常に有効・数値は predicate(値) が true なら無効化 */
  function applyDisable(sel, predicate) {
    for (var i = 0; i < sel.options.length; i++) {
      var opt = sel.options[i];
      if (opt.value === '') { opt.disabled = false; continue; }
      var n = num(opt.value);
      opt.disabled = n != null && predicate(n);
    }
  }

  /* SP は iOS のフォーカスズーム回避で select を 16px にするため、表示値だけを 13px の
     ラベルで見せる（CSS 側で SP のみ表示）。select の文字は SP で transparent にしている。 */
  function mountLabel(sel) {
    var wrap = sel.closest('.pbk-dd');
    if (!wrap) return;
    var el = document.createElement('span');
    el.className = 'pbk-dd__value';
    el.setAttribute('aria-hidden', 'true');
    wrap.insertBefore(el, sel);
    sel.pbkValueLabel = el;
  }

  function syncLabel(sel) {
    var el = sel.pbkValueLabel;
    if (!el) return;
    var opt = sel.options[sel.selectedIndex];
    el.textContent = opt ? opt.textContent : '';
    el.classList.toggle('is-placeholder', sel.value === '');
  }

  function wirePair(minSel, maxSel) {
    function sync(changed) {
      var minV = num(minSel.value);
      var maxV = num(maxSel.value);

      /* 下限が決まっていれば、上限側の「下限未満」を選べなくする */
      applyDisable(maxSel, function (n) { return minV != null && n < minV; });
      /* 上限が決まっていれば、下限側の「上限超過」を選べなくする */
      applyDisable(minSel, function (n) { return maxV != null && n > maxV; });

      /* 既存選択が矛盾（下限 > 上限）した場合、直前に操作した側を優先して他方を「なし」に補正 */
      if (minV != null && maxV != null && minV > maxV) {
        if (changed === maxSel) {
          minSel.value = '';
        } else {
          maxSel.value = '';
        }
        sync(changed); /* 補正後の disabled 状態を張り直す（片側 null になり再帰は 1 段で収束） */
      }

      syncLabel(minSel);
      syncLabel(maxSel);
    }

    minSel.addEventListener('change', function () { sync(minSel); });
    maxSel.addEventListener('change', function () { sync(maxSel); });
    sync(null); /* 初期同期（URL シード等で初期値が入っているケースに対応） */
  }

  function boot() {
    var wired = [];
    var ranges = document.querySelectorAll('.pbk-range');
    for (var i = 0; i < ranges.length; i++) {
      var sels = ranges[i].querySelectorAll('select.pbk-dd__select');
      if (sels.length !== 2) continue;
      mountLabel(sels[0]);
      mountLabel(sels[1]);
      wirePair(sels[0], sels[1]); /* 末尾の初期 sync がラベルも塗る */
      wired.push(sels[0], sels[1]);
    }
    if (!wired.length) return;

    /* 「フィルターをクリア」/ チップ ✕ は select.value を直接書き換えて change を発火しないため、
       クリック後にラベルを張り直す */
    document.addEventListener('click', function () {
      requestAnimationFrame(function () {
        for (var j = 0; j < wired.length; j++) syncLabel(wired[j]);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
